import React, { useState, useRef, useEffect, useMemo } from "react";
import {TextField,
        Grid,
        Typography,
        FormHelperText
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import parse from 'autosuggest-highlight/parse';
import throttle from 'lodash/throttle';
import useStyles from './styles'

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('async', '');
  script.setAttribute('id', id);
  script.src = src;
  position.appendChild(script);
}

const autocompleteService = { current: null };
const geocodeService = { current: null };

export default function AddressAutoComplete(props) {
    const { onLocationUpdate, presetValue, label, placeTypes, helperText } = props
    const classes = useStyles();
    const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [placeId, setPlaceId] = useState('');
    const [prePlaceId, setPrePlaceId] = useState('');
    const [options, setOptions] = useState([]);
    const loaded = useRef(false);
    const placeTypesList = {'default': [], 'suburb': ['neighborhood', 'sublocality'], 'city': ['(cities)'], 'suburb_city': ['(regions)']}

    if (typeof window !== 'undefined' && !loaded.current) {
      if (!document.querySelector('#google-maps')) {
        loadScript(
          'https://maps.googleapis.com/maps/api/js?key=AIzaSyA2lBjkVrTQtZfnzGvILkgpdAsq49nHsH8&libraries=places,geometry',
          document.querySelector('head'),
          'google-maps',
        );
      }

      loaded.current = true;
    }

    const fetch = useMemo(
      () =>
        throttle((request, callback) => {
          autocompleteService.current.getPlacePredictions(request, callback);
        }, 200),
      [],
    );

    const fetchGeocode= useMemo(
      () =>
        throttle((request, callback) => {
          geocodeService.current.geocode(request, callback);
        }, 200),
      [],
    );

    useEffect(() => {
      if (presetValue !== undefined && presetValue !== null) {
        setValue(presetValue);
      }
    },[presetValue]);

    useEffect(() => {
      let active = true;

      if (!autocompleteService.current && window.google) {
        autocompleteService.current = new window.google.maps.places.AutocompleteService();
      }
      if (!autocompleteService.current) {
        return undefined;
      }

      if (inputValue === '') {
        setOptions(value ? [value] : []);
        return undefined;
      }
      fetch({ input: inputValue,
              types: placeTypes === undefined || placeTypes === null ? placeTypesList.default : placeTypesList[placeTypes],
              componentRestrictions: {
                  country: 'NZ'
               }
            },
            (results) => {
        if (active) {
          let newOptions = [];

          if (value) {
            newOptions = [value];
          }

          if (results) {
            newOptions = [...newOptions, ...results];

          }

          setOptions(newOptions);
        }
      });

      return () => {
        active = false;
      };
    }, [value, inputValue, fetch]);


   useEffect(() => {
     //let active = true;
     if (!geocodeService.current && window.google) {
       geocodeService.current = new window.google.maps.Geocoder();
     }
     if (!geocodeService.current) {
       return undefined;
     }

     if (placeId === undefined || placeId === '') {
       return undefined;
     }
    if (placeId !== prePlaceId) {
      setPrePlaceId(placeId);
     fetchGeocode({ placeId: placeId }, (results) => {
       //if (active) {
         if (results) {
           if (results !== undefined && results.length >= 0) {
             const addressComponent = results[0].address_components.reduce((comp, { long_name, types }) => (types.forEach(t => comp[t] = long_name), comp), {});
             //console.log('addressComponent', addressComponent, results)
             onLocationUpdate(
                {lat:results[0].geometry.location.lat(),
                 lng:results[0].geometry.location.lng(),
                 region: addressComponent.administrative_area_level_1,
                 locality: addressComponent.locality,
                 sublocality: addressComponent.sublocality,
                 //suburb: addressComponent.neighborhood ? addressComponent.neighborhood : addressComponent.sublocality,
                 suburb: results[0].formatted_address,
                 });
          }
         }
       //}
     });
   }

     /*return () => {
       active = false;
     };*/
   }, [placeId, prePlaceId, fetchGeocode, onLocationUpdate]);


  return (
            <Autocomplete
              freeSolo
              id="field-to-complete"
              size="small"
              style={{ marginBottom: 20 }}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.description)}
              filterOptions={(x) => x}
              options={options}
              noOptionsText="Type to search"
              autoComplete
              includeInputInList
              filterSelectedOptions
              value={value}
              onChange={(event, newValue) => {
                if (newValue !== undefined && newValue !== null) {//console.log('onChange', event, newValue);
                  setOptions(newValue ? [newValue, ...options] : options);
                  setValue(newValue);
                  setPlaceId(newValue.place_id);
                  props.onSelect(newValue.description);
                }

              }}
              onInputChange={(event, newInputValue) => {//console.log('onInputChange',event, newInputValue);
                setInputValue(newInputValue);
                props.onSelect(newInputValue);
              }}
              renderInput={(params) => (<>
                <TextField {...params} label={props.label !== undefined && props.lable !== null ? label : 'Search Address'}
                                       variant="outlined"
                                       required={props.required ? props.required : false}
                                       inputProps={{
                                          ...params.inputProps,
                                          autoComplete: 'new-field-to-complete',
                                       }}
                                       multiline
                                       fullWidth />
                {helperText !== undefined && helperText !== null && helperText !== '' &&
                 <FormHelperText >{helperText}</FormHelperText>}</>
              )}
              renderOption={(option) => {
                //console.log(option)
                if (option.structured_formatting !== undefined && option.structured_formatting !== null) {
                  const matches = option.structured_formatting.main_text_matched_substrings;
                  if (matches !== undefined && matches !== null && matches !== '') {
                    const parts = parse(
                      option.structured_formatting.main_text,
                      matches.map((match) => [match.offset, match.offset + match.length]),
                      );

                      return (
                        <Grid container alignItems="center">
                          <Grid item>
                            <LocationOnIcon className={classes.icon} />
                          </Grid>
                          <Grid item xs>
                            {parts.map((part, index) => (
                              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                                {part.text}
                              </span>
                            ))}

                            <Typography variant="body2" color="textSecondary">
                              {option.structured_formatting.secondary_text}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                  }
              }

              return null;

              }}
            />

  );
}
